import React, {useState} from "react";
import Modal from "react-modal";
import CrossIcon from "@safecv/assets/Images/cross.png";
import CopyIcon from "../../../assets/Images/copy_icon.svg";

const customModalStyles = {
  content: {
    top: "50%",
    left: "50%",
    right: "auto",
    bottom: "auto",
    padding: "0px",
    width: "613px",
    overflow: "hidden",
    borderRadius: "0px",
    transform: "translate(-50%, -50%)",
  },
};

Modal.defaultStyles.overlay.backgroundColor = "rgb(0, 0, 0, 0.5)";

const ShowMoreCodebookModal = (props) => {

  const { heading, details, handleCopy, handleCloseMenu } = props;
  const [isModalOpen, setIsModalOpen] = useState(false);

  const handleModalOpen = () => {
    handleCloseMenu();
    setIsModalOpen(true);
  };

  const handleModalClose = () => {
    setIsModalOpen(false);
  };

  return (
    <>
      <div className="showmorecodebook-moretext pointer-css" onClick={handleModalOpen}>
        Show more
      </div>
      <Modal
        ariaHideApp={false}
        isOpen={isModalOpen}
        style={customModalStyles}
        onRequestClose={handleModalClose}
        contentLabel="Showmore Codebook Modal"
      >
        <div className="modal-showmorecodebook">
          <header>
            <span className="showmorecodebook-header-title">CODEBOOK</span>
            <span onClick={handleModalClose} className="pointer-css">
              <img src={CrossIcon} alt="Close icon" />
            </span>
          </header>

          <section>

            <div>
              <div style={{ display: "flex" }}>
                <div className="showmorecodebook-content-heading">
                  {heading}
                </div>
                <div className="showmorecodebook-content-copy">
                  <img 
                    src={CopyIcon}
                    alt="Copy Icon"
                    onClick={() => handleCopy(heading+ " : " +details)}
                    className="showmorecodebook-content-copyimage pointer-css"
                  />
                </div>
              </div>
            </div>

            <div className="showmorecodebook-type-box">
              {details}
            </div>

          </section>
        </div>
      </Modal>
    </>
  );
};

export default ShowMoreCodebookModal;
